export interface SpecialSection {
  id: string;
  name: string;
  note: string;
  items: { label: string; href: string; meta: string }[];
}

export interface SpecialItem {
  id: string;
  title: string;
  kicker: string;
  tag: string;
  cover: string;
  intro: string;
  period: string;
  articleCount: number;
  sections: SpecialSection[];
}

export const specialList: SpecialItem[] = [
  {
    id: "s001",
    title: "镜头里的二十年：从飘飘到林书仪",
    kicker: "年度策划",
    tag: "影视回顾",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20collage%20style%20image%20of%20an%20old%20film%20projector%20casting%20warm%20light%20in%20a%20dark%20room%2C%20dust%20particles%20in%20the%20beam%2C%20stacked%20film%20reels%20and%20a%20small%20screen%20showing%20a%20blurred%20portrait%2C%20nostalgic%20amber%20and%20charcoal%20palette%2C%20artistic%20editorial%20photography&width=1600&height=900&seq=cecilia-special-001&orientation=landscape",
    intro:
      "从一九九九年的海边，到即将上映的旧书店，我们把二十多年里她最重要的九个角色重新排了一次序。不是排名，而是一条能看得见变化的线。",
    period: "2026 年 10 月 — 12 月",
    articleCount: 9,
    sections: [
      {
        id: "ss001a",
        name: "第一部分 · 起点",
        note: "被镜头选中的那几年",
        items: [
          { label: "海边那句回答：《喜剧之王》里的第一次亮相", href: "/news/n003", meta: "深度解读" },
          { label: "作品档案：喜剧之王", href: "/works/w003", meta: "1999 · 电影" },
          { label: "旧作《忘不了》重映定档，胶片修复版保留原始色调", href: "/news/n005", meta: "影视资讯" },
        ],
      },
      {
        id: "ss001b",
        name: "第二部分 · 转向",
        note: "把漂亮收起来，把人物留下来",
        items: [
          { label: "一场三分钟哭戏拍了整夜", href: "/news/n010", meta: "剧组手记" },
          { label: "作品档案：影子爱人", href: "/works/w008", meta: "2012 · 电影" },
          { label: "五十岁之后：一份“不再做的事”清单", href: "/news/n012", meta: "深度访谈" },
        ],
      },
      {
        id: "ss001c",
        name: "第三部分 · 现在",
        note: "她把节奏慢了下来",
        items: [
          { label: "新片《南方来信》首曝预告", href: "/news/n002", meta: "影视前线" },
          { label: "作品档案：南方来信", href: "/works/w001", meta: "2027 · 电影" },
          { label: "时隔三年再登杂志封面", href: "/news/n001", meta: "独家访谈" },
        ],
      },
    ],
  },
  {
    id: "s002",
    title: "光影留白：年度写真合集",
    kicker: "图片策划",
    tag: "写真精选",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20studio%20still%20life%20with%20a%20large%20empty%20wooden%20stool%20under%20a%20soft%20beam%20of%20window%20light%2C%20sheer%20curtain%20moving%20slightly%2C%20warm%20beige%20walls%20with%20gentle%20shadows%2C%20minimal%20editorial%20photography%2C%20quiet%20contemplative%20mood%2C%20cream%20and%20amber%20palette&width=1600&height=900&seq=cecilia-special-002&orientation=landscape",
    intro:
      "一年里，她在镜头前留下的那些几乎没有动作的瞬间。我们选出了十五张照片，按光线而不是时间来排列。",
    period: "2026 年 7 月 — 10 月",
    articleCount: 15,
    sections: [
      {
        id: "ss002a",
        name: "光从左边来",
        note: "棚拍与自然光的交界",
        items: [
          { label: "暖灰影棚 · 封面写真", href: "/gallery", meta: "写真" },
          { label: "窗边侧影", href: "/gallery", meta: "写真" },
          { label: "白色空间", href: "/gallery", meta: "写真" },
        ],
      },
      {
        id: "ss002b",
        name: "老屋与黄昏",
        note: "氛围感来自环境，而非造型",
        items: [
          { label: "旧屋与光", href: "/gallery", meta: "写真" },
          { label: "午后庭院", href: "/gallery", meta: "写真" },
          { label: "胶片中的她", href: "/gallery", meta: "写真" },
        ],
      },
    ],
  },
  {
    id: "s003",
    title: "不止于表演：她的公益十二年",
    kicker: "深度报道",
    tag: "公益纪实",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20documentary%20photograph%20of%20a%20rural%20school%20library%20with%20wooden%20shelves%20of%20books%2C%20sunlight%20falling%20across%20the%20floor%2C%20a%20few%20open%20books%20on%20a%20low%20table%2C%20hopeful%20gentle%20atmosphere%2C%20earthy%20beige%20and%20ochre%20palette&width=1600&height=900&seq=cecilia-special-003&orientation=landscape",
    intro:
      "十二年间，她参与的公益项目大多没有发布会。这篇报道试图还原这些不太被看见的部分。",
    period: "2026 年 9 月 — 11 月",
    articleCount: 5,
    sections: [
      {
        id: "ss003a",
        name: "课堂之内",
        note: "为什么选择做教育",
        items: [
          { label: "公益活动走进乡村小学，为孩子们上第一堂表演课", href: "/news/n006", meta: "公益记录" },
          { label: "同行的志愿者：她几乎没有明星的架子", href: "/news/n006", meta: "现场手记" },
        ],
      },
      {
        id: "ss003b",
        name: "课堂之外",
        note: "她谈到如何面对误解",
        items: [
          { label: "回应外界传闻：希望把注意力放回作品本身", href: "/news/n007", meta: "求证频道" },
          { label: "生活手记：她的冰箱里有三样东西从不缺席", href: "/news/n008", meta: "生活" },
        ],
      },
    ],
  },
  {
    id: "s004",
    title: "港片回望：我们为什么还在看九十年代",
    kicker: "主题策划",
    tag: "影史专题",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20night%20view%20of%20a%20hong%20kong%20street%20with%20old%20neon%20signs%2C%20wet%20pavement%20reflecting%20warm%20lights%2C%20vintage%20cinema%20marquee%20in%20the%20background%2C%20amber%20and%20deep%20brown%20palette%2C%20cinematic%20film%20grain%2C%20romantic%20melancholic%20mood&width=1600&height=900&seq=cecilia-special-004&orientation=landscape",
    intro:
      "没有特效的年代，镜头如何靠人撑住？我们和几位影评人聊了聊那个年代的方法，也重新看了几场戏。",
    period: "2026 年 8 月 — 10 月",
    articleCount: 6,
    sections: [
      {
        id: "ss004a",
        name: "表演的方法",
        note: "长镜头里的呼吸",
        items: [
          { label: "作品档案：忘不了", href: "/works/w002", meta: "2003 · 电影" },
          { label: "作品档案：喜剧之王", href: "/works/w003", meta: "1999 · 电影" },
        ],
      },
      {
        id: "ss004b",
        name: "城市的记忆",
        note: "银幕上的街道如何塑造人",
        items: [
          { label: "作品档案：一路有你", href: "/works/w009", meta: "2010 · 电影" },
          { label: "作品档案：如果·爱", href: "/works/w006", meta: "2005 · 电影" },
        ],
      },
    ],
  },
];

export const suggestKeywords = ["南方来信", "忘不了", "写真", "公益", "综艺", "访谈", "港片", "封面"];